import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

export const FormCheckbox = ({
  id,
  name,
  containerClass,
  label,
  value,
  ...props
}) => {
  const [checked, setChecked] = useState(false);
  const methods = useFormContext();

  const onChange = (e) => {
    setChecked(!checked);
  };

  return (
    <div className="input-group">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        data-value={value}
        onClick={onChange}
        {...methods.register(name)}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};
